import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/components/sg/faq";

export function FaqList({ limit }) {
  const items = limit ? FAQ.slice(0, limit) : FAQ;
  return (
    <Accordion type="single" collapsible className="border border-border rounded-xl bg-card px-5" data-testid="faq-list">
      {items.map((f, i) => (
        <AccordionItem key={f.q} value={`q${i}`} className={i === items.length - 1 ? "border-b-0" : ""}>
          <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-semibold hover:no-underline">{f.q}</AccordionTrigger>
          <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
